/** 主页面路由 **/
export default [{
        path: '/consumerAccount/:session/:mobile/',
        name: 'consumerAccount',
        meta: {
            title: '消费账户',
        },
        component: () => import('@/views/consumerAccount/consumerAccount.vue'),
    },
    {
        path: '/refuelingCard/:session/:mobile/:type/',
        name: 'refuelingCard',
        meta: {
            title: '加油卡',
        },
        component: () => import('@/views/consumerAccount/refuelingCard.vue'),
    },
    {
        path: '/refuelingCardList/:session/:mobile/',
        name: 'refuelingCardList',
        meta: {
            title: '加油卡消费列表',
        },
        component: () => import('@/views/consumerAccount/refuelingCardList.vue'),
    },
    {
        path: '/refuelingCardDetail/:session/:mobile/:id/',
        name: 'refuelingCardDetail',
        meta: {
            title: '加油卡消费详情',
        },
        component: () => import('@/views/consumerAccount/refuelingCardDetail.vue'),
    }
]